/* Perfyra signup popup — phone + email subscribe (AJAX, no page reload) */
(function () {
  if (window.__pfSignupAjaxReady) return;
  window.__pfSignupAjaxReady = true;

  var DIAL_MAP = { AE: '+971', SA: '+966', KW: '+965', QA: '+974', BH: '+973', OM: '+968', JO: '+962' };

  function syncDial(form) {
    var dial = form.querySelector('[data-pf-signup-dial]');
    if (!dial) return;
    try {
      var code = (localStorage.getItem('perfyra-gulf-country') || '').toUpperCase();
      if (DIAL_MAP[code]) dial.value = DIAL_MAP[code];
    } catch (e) {}
  }

  function normalizeNational(raw, dialCode) {
    var d = String(raw || '').replace(/\D/g, '');
    var cc = String(dialCode || '').replace(/\D/g, '');
    if (cc && d.indexOf(cc) === 0) d = d.slice(cc.length);
    if (d.charAt(0) === '0') d = d.slice(1);
    return d;
  }

  function buildE164(form) {
    var dial = form.querySelector('[data-pf-signup-dial]');
    var phone = form.querySelector('[data-pf-signup-phone]');
    var dialCode = dial ? dial.value : '+971';
    var national = normalizeNational(phone && phone.value, dialCode);
    return {
      dialCode: dialCode,
      national: national,
      e164: dialCode + national,
      digits: (dialCode + national).replace(/\D/g, '')
    };
  }

  function showError(form, msg) {
    var el = form.querySelector('[data-pf-signup-error]');
    if (!el) return;
    el.hidden = false;
    el.textContent = msg;
  }

  function clearError(form) {
    var el = form.querySelector('[data-pf-signup-error]');
    if (!el) return;
    el.hidden = true;
    el.textContent = '';
  }

  function setBusy(form, busy) {
    var btn = form.querySelector('[data-pf-signup-submit]');
    if (!btn) return;
    btn.disabled = !!busy;
    if (busy) btn.setAttribute('aria-busy', 'true');
    else btn.removeAttribute('aria-busy');
  }

  function isArabic(form) {
    var body = form.querySelector('[data-pf-signup-body]');
    if (body && body.getAttribute('data-pf-ar') === '1') return true;
    if (form.getAttribute('data-pf-ar') === '1') return true;
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('ar') === 0;
  }

  function fillFields(form, payload) {
    var emailInput = form.querySelector('[data-pf-signup-email-input]');
    if (emailInput) {
      emailInput.setAttribute('name', 'contact[email]');
      emailInput.value = payload.email || '';
      emailInput.disabled = false;
      emailInput.removeAttribute('disabled');
    }

    var phoneVal = payload && payload.phone ? String(payload.phone) : '';
    var emailVal = payload && payload.email ? String(payload.email) : '';

    var phoneHidden = form.querySelector('[data-pf-signup-phone-hidden]');
    if (phoneHidden) {
      phoneHidden.setAttribute('name', 'contact[phone]');
      phoneHidden.value = phoneVal;
    }

    // Shopify customer list "Customer" column shows first_name when set.
    // Keep email as contact[email] so it still appears on the customer page.
    var firstHidden = form.querySelector('[data-pf-signup-firstname-hidden]');
    if (firstHidden) {
      firstHidden.setAttribute('name', 'contact[first_name]');
      firstHidden.value = phoneVal;
    }

    var noteHidden = form.querySelector('[data-pf-signup-note-hidden]');
    if (noteHidden) {
      noteHidden.setAttribute('name', 'contact[note]');
      noteHidden.value = phoneVal
        ? ('Phone: ' + phoneVal + (emailVal ? ' | Email: ' + emailVal : ''))
        : '';
    }
  }

  function rememberSuccess(form, payload) {
    try {
      if (payload && payload.email) localStorage.setItem('pf-signup-email', payload.email);
      if (payload && payload.phone) localStorage.setItem('pf-signup-phone', payload.phone);
      else if (payload && payload.email) localStorage.setItem('pf-signup-phone', payload.email);
      var body = form.querySelector('[data-pf-signup-body]');
      var sid = (body && body.getAttribute('data-pf-section')) || form.getAttribute('data-pf-section') || '';
      if (sid) {
        localStorage.setItem(sid, JSON.stringify({
          section: sid,
          expires: Date.now() + 7 * 24 * 60 * 60 * 1000
        }));
      }
    } catch (e) {}
    clearDismissed();
    hideReopen();
  }

  function isUnlocked(form) {
    return form && form.getAttribute('data-pf-signup-unlocked') === '1';
  }

  function unlockEmail(form) {
    if (!form) return;
    clearError(form);
    syncDial(form);
    var ar = isArabic(form);
    var phone = form.querySelector('[data-pf-signup-phone]');
    var built = buildE164(form);
    if (!phone || built.national.length < 7 || built.national.length > 12) {
      var msgPhone = ar ? 'يرجى إدخال رقم جوال صحيح' : 'Please enter a valid mobile number';
      if (phone) {
        phone.setCustomValidity(msgPhone);
        phone.reportValidity();
      } else {
        showError(form, msgPhone);
      }
      return;
    }
    phone.setCustomValidity('');
    form.setAttribute('data-pf-phone-e164', built.e164);
    form.setAttribute('data-pf-signup-unlocked', '1');

    var unlockBtn = form.querySelector('[data-pf-signup-unlock]');
    if (unlockBtn) unlockBtn.hidden = true;

    var emailBlock = form.querySelector('[data-pf-signup-email-block]');
    if (emailBlock) emailBlock.hidden = false;

    var emailInput = form.querySelector('[data-pf-signup-email-input]');
    if (emailInput) {
      emailInput.required = true;
      setTimeout(function () { try { emailInput.focus(); } catch (e) {} }, 50);
    }
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  var __pfSignupWasOpened = false;
  var DISMISS_KEY = 'pf-signup-dismissed';

  function hasSubscribed() {
    try {
      if (localStorage.getItem('pf-signup-phone') || localStorage.getItem('pf-signup-email')) return true;
    } catch (e) {}
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('customer_posted') === 'true') return true;
    } catch (e2) {}
    return false;
  }

  function wasDismissed() {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markDismissed() {
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch (e) {}
  }

  function clearDismissed() {
    try {
      sessionStorage.removeItem(DISMISS_KEY);
    } catch (e) {}
  }

  function reopenBtn() {
    return document.querySelector('[data-pf-signup-reopen]');
  }

  function ensureReopenBtn() {
    var btn = reopenBtn();
    if (btn) {
      if (btn.parentNode !== document.body) document.body.appendChild(btn);
      return btn;
    }
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pf-signup-popup__reopen';
    btn.setAttribute('data-pf-signup-reopen', '');
    btn.setAttribute('aria-label', '10%');
    btn.hidden = true;
    btn.innerHTML =
      '<span class="pf-signup-popup__reopen-inner" aria-hidden="true">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">' +
      '<path d="M20 12v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>' +
      '<path d="M4 8h16v4H4V8z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>' +
      '<path d="M12 21V8M12 8H8.5a2.5 2.5 0 1 1 0-5C11 3 12 8 12 8zm0 0h3.5a2.5 2.5 0 1 0 0-5C13 3 12 8 12 8z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '<span class="pf-signup-popup__reopen-pct">10%</span>' +
      '</span>';
    document.body.appendChild(btn);
    return btn;
  }

  function hideReopen() {
    var btn = reopenBtn();
    if (btn) btn.hidden = true;
  }

  function showReopen() {
    if (hasSubscribed()) {
      hideReopen();
      return;
    }
    if (!__pfSignupWasOpened && !wasDismissed()) return;
    var btn = ensureReopenBtn();
    btn.hidden = false;
  }

  function onOpened() {
    __pfSignupWasOpened = true;
    hideReopen();
  }

  function onClosed() {
    __pfSignupWasOpened = true;
    markDismissed();
    showReopen();
  }

  function getSignupData() {
    if (!window.Alpine || typeof Alpine.$data !== 'function') return null;
    var candidates = [
      document.querySelector('.pf-signup-popup__shell'),
      document.querySelector('.section-pf-signup-popup [x-data*="xPopups"]'),
      document.querySelector('.section-pf-signup-popup [x-data]'),
      document.querySelector('#x-pf-signup-popup-' + ((document.querySelector('[data-pf-signup-body]') || {}).getAttribute ? document.querySelector('[data-pf-signup-body]').getAttribute('data-pf-section') : ''))
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (!el) continue;
      try {
        var data = Alpine.$data(el);
        if (data && typeof data.close === 'function' && 'show' in data) return data;
      } catch (e) {}
    }
    return null;
  }

  function clearSignupExpire() {
    try {
      var body = document.querySelector('[data-pf-signup-body]');
      var sid = (body && body.getAttribute('data-pf-section')) || '';
      if (sid) {
        localStorage.removeItem(sid);
        localStorage.removeItem('current-' + sid);
      }
    } catch (e) {}
  }

  function openSignupPopup() {
    hideReopen();
    clearSignupExpire();

    var data = getSignupData();
    if (data) {
      try {
        if (typeof data.clickMinimal === 'function') {
          data.clickMinimal();
        } else {
          data.showMinimal = false;
          data.show = true;
          if (typeof data.setOverlay === 'function') data.setOverlay();
          if (typeof data.saveDisplayedPopup === 'function') data.saveDisplayedPopup();
        }
      } catch (e) {}
      document.documentElement.classList.add('pf-signup-popup-open');
      document.body.classList.add('overflow-hidden');
      return;
    }

    // Last resort: force the shell visible without Alpine
    var shell = document.querySelector('.pf-signup-popup__shell');
    if (shell) {
      shell.style.display = 'flex';
      shell.style.opacity = '1';
      shell.removeAttribute('hidden');
      document.documentElement.classList.add('pf-signup-popup-open');
      document.body.classList.add('overflow-hidden');
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-pf-signup-reopen]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    openSignupPopup();
  }, true);

  var COUPON_FLAG = 'pf-signup-show-coupon';
  var COUPON_FLAG_LS = 'pf-signup-show-coupon-ls';

  function markCouponPending() {
    try { sessionStorage.setItem(COUPON_FLAG, '1'); } catch (e1) {}
    try {
      localStorage.setItem(COUPON_FLAG_LS, JSON.stringify({ t: Date.now() }));
    } catch (e2) {}
  }

  function clearCouponPending() {
    try { sessionStorage.removeItem(COUPON_FLAG); } catch (e1) {}
    try { localStorage.removeItem(COUPON_FLAG_LS); } catch (e2) {}
  }

  function hasCouponPending() {
    try {
      if (sessionStorage.getItem(COUPON_FLAG) === '1') return true;
    } catch (e1) {}
    try {
      var raw = localStorage.getItem(COUPON_FLAG_LS);
      if (!raw) return false;
      var data = JSON.parse(raw);
      // Keep pending for 30 minutes across captcha redirect
      if (data && data.t && (Date.now() - data.t) < 30 * 60 * 1000) return true;
      localStorage.removeItem(COUPON_FLAG_LS);
    } catch (e2) {}
    return false;
  }

  function hideChallengeUi(form) {
    var challenge = form.querySelector('[data-pf-signup-challenge]');
    if (challenge) challenge.hidden = true;
    var body = form.querySelector('[data-pf-signup-body]');
    if (body) body.hidden = false;
  }

  function validateAndPrepare(form) {
    clearError(form);
    hideChallengeUi(form);
    syncDial(form);

    if (!isUnlocked(form)) {
      unlockEmail(form);
      return false;
    }

    var ar = isArabic(form);
    var emailInput = form.querySelector('[data-pf-signup-email-input]');
    var emailVal = emailInput ? String(emailInput.value || '').trim() : '';
    var phoneE164 = form.getAttribute('data-pf-phone-e164') || '';
    if (!phoneE164) {
      var built = buildE164(form);
      phoneE164 = built.e164;
    }

    if (!phoneE164 || phoneE164.replace(/\D/g, '').length < 8) {
      showError(form, ar ? 'يرجى إدخال رقم جوال صحيح' : 'Please enter a valid mobile number');
      return false;
    }

    if (!isValidEmail(emailVal)) {
      var msgEmail = ar ? 'يرجى إدخال بريد إلكتروني صحيح' : 'Please enter a valid email address';
      if (emailInput) {
        emailInput.setCustomValidity(msgEmail);
        emailInput.reportValidity();
      } else {
        showError(form, msgEmail);
      }
      return false;
    }
    if (emailInput) emailInput.setCustomValidity('');

    var payload = { email: emailVal, phone: phoneE164 };
    fillFields(form, payload);
    rememberSuccess(form, payload);
    markCouponPending();
    return true;
  }

  function prepareForm(form) {
    if (!form) return;
    form.removeAttribute('target');
    if (form.getAttribute('data-pf-phone-bound') === '1') return;
    form.setAttribute('data-pf-phone-bound', '1');

    var body = form.querySelector('[data-pf-signup-body]');
    if (body) {
      if (body.getAttribute('data-pf-section')) form.setAttribute('data-pf-section', body.getAttribute('data-pf-section'));
      if (body.getAttribute('data-pf-ar')) form.setAttribute('data-pf-ar', body.getAttribute('data-pf-ar'));
    }
    syncDial(form);
    form.removeAttribute('data-pf-signup-unlocked');
    form.removeAttribute('data-pf-phone-e164');

    var unlockBtn = form.querySelector('[data-pf-signup-unlock]');
    if (unlockBtn) {
      unlockBtn.hidden = false;
      unlockBtn.addEventListener('click', function (ev) {
        ev.preventDefault();
        unlockEmail(form);
      });
    }
    var emailBlock = form.querySelector('[data-pf-signup-email-block]');
    if (emailBlock) emailBlock.hidden = true;

    var phone = form.querySelector('[data-pf-signup-phone]');
    if (phone) {
      phone.required = false;
      phone.addEventListener('input', function () {
        phone.setCustomValidity('');
        clearError(form);
      });
    }

    var emailInput = form.querySelector('[data-pf-signup-email-input]');
    if (emailInput) {
      emailInput.required = true;
      emailInput.addEventListener('input', function () {
        emailInput.setCustomValidity('');
        clearError(form);
      });
    }
  }

  function readyCaptcha(form) {
    prepareForm(form);
  }

  function findForm(fromEl) {
    if (!fromEl) return null;
    return fromEl.closest ? fromEl.closest('form.pf-signup-popup__form') : null;
  }

  // Do NOT hijack submit with form.submit()/fetch — Shopify bot protection needs a real browser POST.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('pf-signup-popup__form')) return;

    if (!validateAndPrepare(form)) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    setBusy(form, true);
    // allow default submit → reload / captcha → Flow email
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var phone = e.target && e.target.closest ? e.target.closest('[data-pf-signup-phone]') : null;
    if (!phone) return;
    var form = findForm(phone);
    if (!form) return;
    e.preventDefault();
    prepareForm(form);
    if (!isUnlocked(form)) unlockEmail(form);
  }, true);

  var COUPON_CODE = 'WELCOME10';

  function getCouponCode() {
    var body = document.querySelector('[data-pf-signup-body][data-pf-coupon-code]');
    if (body) {
      var fromAttr = body.getAttribute('data-pf-coupon-code');
      if (fromAttr) return String(fromAttr).trim();
    }
    var codeEl = document.querySelector('[data-pf-signup-coupon-code]');
    if (codeEl && codeEl.textContent) return String(codeEl.textContent).trim();
    return COUPON_CODE;
  }
  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.cssText = 'position:fixed;left:-9999px;top:0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  }

  function bindCouponCopy(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('[data-pf-signup-coupon-copy]');
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].getAttribute('data-pf-copy-bound') === '1') continue;
      buttons[i].setAttribute('data-pf-copy-bound', '1');
      buttons[i].addEventListener('click', function (ev) {
        var btn = ev.currentTarget;
        var wrap = btn.closest('[data-pf-signup-coupon]');
        var codeEl = wrap ? wrap.querySelector('[data-pf-signup-coupon-code]') : null;
        var code = (codeEl && codeEl.textContent) || getCouponCode();
        var label = btn.getAttribute('data-copy-label') || 'Copy';
        var copied = btn.getAttribute('data-copied-label') || 'Copied';
        copyText(String(code).trim()).then(function () {
          btn.textContent = copied;
          setTimeout(function () { btn.textContent = label; }, 1800);
        }).catch(function () {
          btn.textContent = label;
        });
      });
    }
  }

  function showCouponSuccess() {
    clearCouponPending();
    hideReopen();

    var form = document.querySelector('form.pf-signup-popup__form');
    var body = form && form.querySelector('[data-pf-signup-body]');
    var challenge = form && form.querySelector('[data-pf-signup-challenge]');
    var success = form && form.querySelector('[data-pf-signup-success]');
    if (body) body.hidden = true;
    if (challenge) challenge.hidden = true;
    if (success) {
      success.hidden = false;
      bindCouponCopy(success);
    }

    var data = getSignupData();
    if (data) {
      try {
        data.showMinimal = false;
        data.show = true;
        if (typeof data.setOverlay === 'function') data.setOverlay();
      } catch (e2) {}
    } else {
      var shell = document.querySelector('.pf-signup-popup__shell');
      if (shell) {
        shell.style.display = 'flex';
        shell.style.opacity = '1';
        shell.removeAttribute('hidden');
        document.documentElement.classList.add('pf-signup-popup-open');
        document.body.classList.add('overflow-hidden');
      }
    }

    // Fallback floating coupon if form not in DOM yet
    if (!success) {
      showCouponOverlay();
    }
  }

  function showCouponOverlay() {
    if (document.querySelector('[data-pf-signup-coupon-overlay]')) return;
    var ar = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
    var title = ar ? 'كود الخصم الخاص بك' : 'Your discount code';
    var note = ar ? 'تم التسجيل بنجاح. استخدم الكود أدناه.' : 'Signup successful. Use the code below.';
    var copyLabel = ar ? 'نسخ' : 'Copy';
    var copiedLabel = ar ? 'تم النسخ' : 'Copied';
    var overlay = document.createElement('div');
    overlay.setAttribute('data-pf-signup-coupon-overlay', '');
    overlay.className = 'pf-signup-popup__coupon-overlay';
    overlay.innerHTML =
      '<div class="pf-signup-popup__coupon-card" role="dialog" aria-modal="true">' +
      '<button type="button" class="pf-signup-popup__coupon-close" data-pf-coupon-close aria-label="Close">×</button>' +
      '<p class="pf-signup-popup__coupon-title">' + title + '</p>' +
      '<p class="pf-signup-popup__coupon-note">' + note + '</p>' +
      '<div class="pf-signup-popup__coupon" data-pf-signup-coupon>' +
      '<code class="pf-signup-popup__coupon-code" data-pf-signup-coupon-code>' + getCouponCode() + '</code>' +
      '<button type="button" class="pf-signup-popup__coupon-copy" data-pf-signup-coupon-copy data-copy-label="' + copyLabel + '" data-copied-label="' + copiedLabel + '">' + copyLabel + '</button>' +
      '</div></div>';
    document.body.appendChild(overlay);
    document.documentElement.classList.add('pf-signup-popup-open');
    document.body.classList.add('overflow-hidden');
    bindCouponCopy(overlay);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || (e.target.closest && e.target.closest('[data-pf-coupon-close]'))) {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        document.documentElement.classList.remove('pf-signup-popup-open');
        document.body.classList.remove('overflow-hidden');
      }
    });
  }

  function showPostedToast() {
    showCouponSuccess();
  }

  function openCouponAfterRedirect() {
    var tries = 0;
    var tick = function () {
      tries += 1;
      var hasForm = !!document.querySelector('form.pf-signup-popup__form');
      var hasShell = !!document.querySelector('.pf-signup-popup__shell');
      if (hasForm || hasShell || tries >= 20) {
        showCouponSuccess();
        // If Alpine popup still not ready, floating overlay is the backup
        if (!document.querySelector('[data-pf-signup-success]:not([hidden])') &&
            !document.querySelector('[data-pf-signup-coupon-overlay]')) {
          showCouponOverlay();
        }
        return;
      }
      setTimeout(tick, 250);
    };
    setTimeout(tick, 300);
  }

  try {
    var onChallenge = window.location.pathname.indexOf('/challenge') === 0;
    if (onChallenge) {
      // Keep pending flag — do NOT clear it here (that hid the code after captcha)
      markCouponPending();
    } else {
      var params = new URLSearchParams(window.location.search);
      var showCoupon = hasCouponPending();
      if (params.get('customer_posted') === 'true' || params.get('form_type') === 'customer') {
        markCouponPending();
        showCoupon = true;
        try { localStorage.setItem('pf-signup-phone', localStorage.getItem('pf-signup-phone') || '1'); } catch (e0) {}
        hideReopen();
        if (window.history && history.replaceState) {
          params.delete('customer_posted');
          var next = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
          history.replaceState({}, '', next);
        }
      }
      if (showCoupon) {
        try { localStorage.setItem('pf-signup-phone', localStorage.getItem('pf-signup-phone') || '1'); } catch (e6) {}
        hideReopen();
        if (document.body) openCouponAfterRedirect();
        else document.addEventListener('DOMContentLoaded', openCouponAfterRedirect);
      }
    }
  } catch (e) {}

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-pf-signup-coupon-copy]')) {
      bindCouponCopy(document);
    }
  });

  if (hasSubscribed()) {
    hideReopen();
  } else if (wasDismissed()) {
    __pfSignupWasOpened = true;
    if (document.body) showReopen();
    else document.addEventListener('DOMContentLoaded', showReopen);
  } else {
    // Recover after a prior dismiss (expire saved) so the left tab still appears
    var tries = 0;
    var recover = setInterval(function () {
      tries += 1;
      if (hasSubscribed()) {
        clearInterval(recover);
        hideReopen();
        return;
      }
      var body = document.querySelector('[data-pf-signup-body]');
      if (!body) {
        if (tries >= 40) clearInterval(recover);
        return;
      }
      clearInterval(recover);
      var sid = body.getAttribute('data-pf-section') || '';
      if (!sid) return;
      try {
        var item = JSON.parse(localStorage.getItem(sid) || 'null');
        if (item && item.expires && item.expires > Date.now()) {
          __pfSignupWasOpened = true;
          markDismissed();
          showReopen();
        }
      } catch (e3) {}
    }, 250);
  }

  document.addEventListener('perfyra:country-changed', function () {
    document.querySelectorAll('form.pf-signup-popup__form').forEach(syncDial);
  });
  document.addEventListener('perfyra:country-ready', function () {
    document.querySelectorAll('form.pf-signup-popup__form').forEach(syncDial);
  });

  window.pfSignupBind = prepareForm;
  window.pfSignupReadyCaptcha = readyCaptcha;
  window.pfSignupHasSubscribed = hasSubscribed;
  window.pfSignupOnOpened = onOpened;
  window.pfSignupOnClosed = onClosed;
  window.pfSignupHideReopen = hideReopen;
  window.pfSignupOpen = openSignupPopup;
})();
